<template>
  <div>
    <div v-if="loading" class="flex justify-center items-center min-h-[200px]">
      <div
        class="w-12 h-12 border-b-2 rounded-full animate-spin border-custom-yellow"
      ></div>
    </div>
    <template v-else>
      <div class="relative mt-5 overflow-x-auto shadow-md sm:rounded-lg">
        <table class="w-full text-left text-gray-700 rtl:text-right">
          <thead>
            <tr class="bg-gray-100">
              <th scope="col" class="p-4">
                <div class="flex items-center">
                  <input
                    id="checkbox-all-search"
                    type="checkbox"
                    class="w-4 h-4 bg-gray-100 border-gray-300 rounded text-custom-yellow focus:ring-custom-yellow dark:focus:ring-custom-yellow dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label for="checkbox-all-search" class="sr-only"
                    >checkbox</label
                  >
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Name
                  <a href="#"
                    ><svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      /></svg
                  ></a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Email
                  <a href="#"
                    ><svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      /></svg
                  ></a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Phone Number
                  <a href="#"
                    ><svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      /></svg
                  ></a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  ID Number
                  <a href="#"
                    ><svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      /></svg
                  ></a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Contact Mode
                  <a href="#"
                    ><svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      /></svg
                  ></a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Department
                  <a href="#"
                    ><svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      /></svg
                  ></a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Registration date
                  <a href="#"
                    ><svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      /></svg
                  ></a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Status
                  <a href="#"
                    ><svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      /></svg
                  ></a>
                </div>
              </th>
              <th scope="col" class="px-6">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, index) in users" :key="index" class="border-b">
              <td class="w-4 p-4">
                <div class="flex items-center">
                  <input
                    :id="'checkbox-table-search-' + index"
                    type="checkbox"
                    class="w-4 h-4"
                  />
                  <label :for="'checkbox-table-search-' + index" class="sr-only"
                    >checkbox</label
                  >
                </div>
              </td>
              <td class="px-6 py-1">
                {{ user.first_name }} {{ user.last_name }}
              </td>
              <td class="px-6 py-1">{{ user.email }}</td>
              <td class="px-6 py-1">{{ user.phone_number }}</td>
              <td class="px-6 py-1">{{ user.id_number }}</td>
              <td class="px-6 py-1">{{ user.contact_mode }}</td>
              <td class="px-6 py-1">
                {{
                  user.user_roles?.[0]?.facility_department?.department?.name ??
                  ""
                }}
              </td>
              <td class="px-6 py-2">
                {{ new Date(user.created_at).toLocaleString() ?? "" }}
              </td>
              <td class="px-6 py-1">
                <span
                  v-if="user.active === false"
                  class="inline-flex items-center rounded-full bg-red-100 px-2 py-0.5 text-sm font-medium text-red-700"
                >
                  Inactive
                </span>
                <span
                  v-else
                  class="inline-flex items-center rounded-full bg-green-100 px-2 py-0.5 text-sm font-medium text-green-700"
                  >{{ user.account_status || "Active" }}</span
                >
              </td>
              <td class="px-4 py-2 align-middle">
                <div class="flex items-center gap-2">
                  <CustomButton
                    label="Details"
                    @click="handleShowDetails(user.user_id)"
                    :disabled="isLoading[user.user_id]"
                    :bg-class="
                      isLoading[user.user_id]
                        ? 'bg-gray-300 cursor-not-allowed'
                        : 'bg-custom-yellow text-sm py-1'
                    "
                  />
                  <div
                    v-if="isLoading[user.user_id]"
                    class="w-5 h-5 border-t-2 border-b-2 border-gray-900 rounded-full animate-spin"
                  ></div>
                  <CustomButton
                    v-if="canDeactivateUser(user)"
                    label="Deactivate"
                    @click="handleDeactivate(user)"
                    :disabled="isDeactivating[user.user_id]"
                    :bg-class="
                      isDeactivating[user.user_id]
                        ? 'bg-gray-300 cursor-not-allowed'
                        : 'bg-red-600 hover:bg-red-700 text-sm py-1'
                    "
                  />
                  <CustomButton
                    v-if="canActivateUser(user)"
                    label="Activate"
                    @click="handleActivate(user)"
                    :disabled="isDeactivating[user.user_id]"
                    :bg-class="
                      isDeactivating[user.user_id]
                        ? 'bg-gray-300 cursor-not-allowed'
                        : 'bg-green-600 hover:bg-green-700 text-sm py-1'
                    "
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="flex flex-col items-center gap-3 mt-4">
        <p v-if="totalCount > 0" class="text-sm text-gray-600">
          Showing {{ rangeStart }}–{{ rangeEnd }} of {{ totalCount }}
        </p>
        <div class="flex justify-center gap-4">
          <button
            @click="previousPage"
            :disabled="currentPage === 1 || loading"
            class="flex items-center gap-2 px-6 py-3 font-bold text-center align-middle transition-all rounded-lg select-none text-custom-blue hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
            type="button"
          >
            <svg
              class="w-6 h-6"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m15 19-7-7 7-7"
              />
            </svg>
            Previous
          </button>
          <div class="flex items-center gap-2">
            <button
              v-for="page in visiblePages"
              :key="page"
              @click="goToPage(page)"
              :disabled="loading"
              :class="{
                'bg-custom-blue text-white': page === currentPage,
                'text-custom-blue': page !== currentPage,
              }"
              class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium transition-all hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
              type="button"
            >
              <span
                class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
              >
                {{ page }}
              </span>
            </button>
          </div>
          <button
            @click="nextPage"
            :disabled="currentPage >= totalPages || loading"
            class="flex items-center gap-2 px-6 py-3 font-bold text-center align-middle transition-all rounded-lg select-none text-custom-blue hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
            type="button"
          >
            Next
            <svg
              class="w-6 h-6"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m9 5 7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div>
      <div
        v-if="totalCount === 0 && !loading"
        class="mt-4 text-center text-gray-500"
      >
        No users found.
      </div>
    </template>
  </div>
</template>
<script>
import CustomButton from "@/components/CustomButton.vue";
import api from "@/services/api";
import { SweetAlertService } from "@/services/SweetAlertService";

// Must stay in sync with ADMIN_ROLE_NAMES in UsersController.
const ADMIN_ROLE_NAMES = ["Admin", "Super Admin"];
const DEACTIVATED_STATUSES = ["inactive", "deactivated", "suspended"];

export default {
  name: "UserManagementTab",
  components: {
    CustomButton,
  },
  created() {
    this.fetchUsers();
  },
  beforeUnmount() {
    clearTimeout(this.searchTimer);
  },
  props: {
    searchQuery: {
      type: String,
      default: "",
    },
  },
  watch: {
    // Searching changes the result set, so always jump back to the first page.
    // Debounced to avoid a request per keystroke.
    searchQuery() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.fetchUsers(1), 300);
    },
  },
  data() {
    return {
      users: [],
      error: null,
      isLoading: {},
      isDeactivating: {},
      loading: false,
      currentPage: 1,
      totalPages: 0,
      totalCount: 0,
      perPage: 10,
      searchTimer: null,
      filters: {
        contactMode: "",
        facility: "",
        department: "",
        registrationDate: "",
        status: "",
      },
    };
  },
  computed: {
    // Filtering and paging are performed server side, so `users` is already the
    // correct page of rows.
    visiblePages() {
      const maxPagesToShow = 5;
      if (this.totalPages <= maxPagesToShow) {
        return Array.from({ length: this.totalPages }, (_, i) => i + 1);
      }
      let startPage = Math.max(
        1,
        this.currentPage - Math.floor(maxPagesToShow / 2),
      );
      let endPage = Math.min(this.totalPages, startPage + maxPagesToShow - 1);
      if (endPage - startPage + 1 < maxPagesToShow) {
        startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }
      return Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i,
      );
    },
    rangeStart() {
      return this.totalCount === 0
        ? 0
        : (this.currentPage - 1) * this.perPage + 1;
    },
    rangeEnd() {
      return Math.min(this.currentPage * this.perPage, this.totalCount);
    },
    userClaims() {
      return this.$store.getters["auth/claims"];
    },
    userData() {
      return this.$store.getters["auth/user"];
    },
    isAdmin() {
      const hasRole = this.$store.getters["auth/hasRole"];
      return ADMIN_ROLE_NAMES.some((name) => hasRole(name));
    },
  },
  methods: {
    isUserDeactivated(user) {
      const status = (user?.account_status || "")
        .toString()
        .trim()
        .toLowerCase();
      return DEACTIVATED_STATUSES.includes(status);
    },
    // Prefer the server-computed flag, which accounts for revoked facility access
    // as well as account_status. Falls back to account_status if absent.
    isUserActive(user) {
      if (typeof user?.active === "boolean") return user.active;
      return !this.isUserDeactivated(user);
    },
    // Only admins may deactivate, and never their own account.
    canDeactivateUser(user) {
      if (!this.isAdmin) return false;
      if (!user || user.user_id === this.userData?.user_id) return false;
      return this.isUserActive(user);
    },
    // Activation mirrors deactivation: admins only, and only for inactive users.
    canActivateUser(user) {
      if (!this.isAdmin) return false;
      if (!user) return false;
      return !this.isUserActive(user);
    },

    async handleActivate(user) {
      const fullName =
        `${user.first_name || ""} ${user.last_name || ""}`.trim() || user.email;

      const result = await SweetAlertService.showConfirmation(
        "Activate user",
        `Activate ${fullName}? They will regain access to this facility and be able to log in again.`,
      );

      if (!result.value) return;

      this.isDeactivating[user.user_id] = true;
      try {
        await api.activateUser(user.user_id);
        await this.fetchUsers();
        SweetAlertService.showSuccess(
          "Success",
          `${fullName} has been activated.`,
        );
      } catch (error) {
        SweetAlertService.showError(
          "Error",
          error.message || "Failed to activate user.",
        );
      } finally {
        delete this.isDeactivating[user.user_id];
      }
    },

    async handleDeactivate(user) {
      const fullName =
        `${user.first_name || ""} ${user.last_name || ""}`.trim() || user.email;

      const result = await SweetAlertService.showConfirmation(
        "Deactivate user",
        `Deactivate ${fullName}? They will lose access to this facility and will no longer be able to log in.`,
      );

      if (!result.value) return;

      this.isDeactivating[user.user_id] = true;
      try {
        await api.deactivateUser(user.user_id);
        await this.fetchUsers();
        SweetAlertService.showSuccess(
          "Success",
          `${fullName} has been deactivated.`,
        );
      } catch (error) {
        SweetAlertService.showError(
          "Error",
          error.message || "Failed to deactivate user.",
        );
      } finally {
        delete this.isDeactivating[user.user_id];
      }
    },
    // URLSearchParams stringifies undefined/null into the literal text "undefined",
    // which the API would treat as a real filter value. Blank filters are omitted.
    buildListParams(page) {
      const params = {
        page: page,
        per_page: this.perPage,
      };
      const optional = {
        search_query: this.searchQuery,
        contact_mode: this.filters.contactMode,
        department_id: this.filters.department,
        registration_date: this.filters.registrationDate,
        status: this.filters.status,
      };
      Object.entries(optional).forEach(([key, value]) => {
        if (
          value !== undefined &&
          value !== null &&
          String(value).trim() !== ""
        ) {
          params[key] = String(value).trim();
        }
      });
      return params;
    },

    async fetchUsers(page = this.currentPage) {
      this.loading = true;
      try {
        const response = await api.getFacilityUsers(this.buildListParams(page));

        this.users = (response.data || []).filter(
          (user) =>
            Array.isArray(user.user_roles) && user.user_roles.length > 0,
        );
        this.currentPage = response.current_page || 1;
        this.totalPages = response.total_pages || 0;
        this.totalCount = response.total_count || 0;
        this.perPage = response.per_page || this.perPage;
      } catch (error) {
        this.error = error.message || "Failed to fetch users";
      } finally {
        this.loading = false;
      }
    },

    goToPage(page) {
      if (page < 1 || page > this.totalPages || page === this.currentPage)
        return;
      this.fetchUsers(page);
    },

    async previousPage() {
      if (this.currentPage > 1) await this.fetchUsers(this.currentPage - 1);
    },

    async nextPage() {
      if (this.currentPage < this.totalPages)
        await this.fetchUsers(this.currentPage + 1);
    },

    async handleShowDetails(userId) {
      this.isLoading[userId] = true;
      try {
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.$router.push({
          name: "NewUserForm",
          params: { userId },
        });
      } catch {
        this.isLoading[userId] = false;
      }
    },

    async applyFilters(filters) {
      this.filters = { ...this.filters, ...filters };
      await this.fetchUsers(1);
    },

    async resetFilters() {
      this.filters = {
        contactMode: "",
        facility: "",
        department: "",
        registrationDate: "",
        status: "",
      };
      await this.fetchUsers(1);
    },
  },
};
</script>

<style lang="css" scoped></style>
